<e-dialog
  [open]="target() !== null"
  (openChange)="onOpenChange($event)"
  [title]="text().title"
  [closeLabel]="text().close"
  size="md"
>
  <ng-template>
    @if (showMyChart()) {
      <label class="chart-edit-my-chart">
        <input
          type="checkbox"
          ngDefaultControl
          name="isMyChart"
          [ngModel]="myChartChecked()"
          (ngModelChange)="myChartChecked.set($event)"
        />
        <span>{{ text().myChartLabel }}</span>
      </label>
    }

    <label class="chart-edit-icon-label">{{ text().iconLabel }}</label>
    <hd-icon-picker [(value)]="icon"></hd-icon-picker>

    <!-- Momentdetails, alleen op gelogde momenten (spec levenstijdlijn 2.10). -->
    @if (momentDetailsAvailable()) {
      <div class="chart-edit-moment-details" data-test-id="chart-edit-moment-details">
        <div class="chart-edit-detail-row">
          <span class="chart-edit-detail-label">{{ text().categoryLabel }}</span>
          <div class="chart-edit-chips">
            @for (option of categories; track option) {
              <button type="button" class="chart-edit-chip"
                      [class.chart-edit-chip--active]="category() === option"
                      (click)="toggleCategory(option)"
                      [attr.data-test-id]="'edit-category-' + option">
                {{ detailLabels().category[option] }}
              </button>
            }
          </div>
        </div>
        @if (mindActive()) {
          <!-- Mind-notitie: centrum en poort bewerkbaar (de conditioneerder blijft zoals bewaard). -->
          <hd-mind-fields
            class="chart-edit-mind"
            [centerOptions]="mindCenterOptions()"
            [gateOptions]="mindGateOptions()"
            [(center)]="mindCenter"
            [(gate)]="mindGate"
            data-test-id="chart-edit-mind"
          ></hd-mind-fields>
        }
        <div class="chart-edit-detail-row">
          <span class="chart-edit-detail-label">{{ text().colorLabel }}</span>
          <hd-color-picker [(value)]="color"></hd-color-picker>
        </div>
        <div class="chart-edit-detail-row">
          <span class="chart-edit-detail-label">{{ text().moodLabel }}</span>
          <hd-dot-picker
            [options]="moodOptions()"
            [value]="moodDotValue()"
            (valueChange)="onMoodPicked($event)"
            testIdPrefix="edit-mood-"
          ></hd-dot-picker>
        </div>
        <div class="chart-edit-detail-row">
          <span class="chart-edit-detail-label">{{ text().vitalityLabel }}</span>
          <div class="chart-edit-chips">
            @for (option of vitalityValues; track option) {
              <button type="button" class="chart-edit-chip"
                      [class.chart-edit-chip--active]="vitality() === option"
                      [title]="detailLabels().vitality[option]"
                      (click)="toggleVitality(option)"
                      [attr.data-test-id]="'edit-vitality-' + option">
                <i class="fas fa-{{ vitalityIcons[option] }}" aria-hidden="true"></i>
              </button>
            }
          </div>
        </div>
        <div class="chart-edit-detail-row chart-edit-detail-row--wrap">
          <span class="chart-edit-detail-label">{{ text().emotionsLabel }}</span>
          <div class="chart-edit-chips">
            @for (emotion of emotionOptions; track emotion.key) {
              <button type="button" class="chart-edit-chip"
                      [class.chart-edit-chip--active]="emotionKeys().includes(emotion.key)"
                      [disabled]="emotionDisabled(emotion.key)"
                      (click)="toggleEmotion(emotion.key)"
                      [attr.data-test-id]="'edit-emotion-' + emotion.key">
                <i class="fas fa-{{ emotion.icon }}" aria-hidden="true"></i>
                {{ detailLabels().emotion[emotion.key] }}
              </button>
            }
          </div>
        </div>
      </div>
    }

    <hd-chart-create-form
      [initial]="initial()"
      [renameOnly]="renameOnly()"
      (calculated)="onCalculated($event)"
      (renamedOnly)="onRenamedOnly($event)"
      (cancelled)="onOpenChange(false)"
    ></hd-chart-create-form>
  </ng-template>
</e-dialog>
